var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-box"},[_c('p',[_vm._v(_vm._s(this.modalMessage))]),_c('button',{on:{"click":function($event){return _vm.$emit('close-modal')}}},[_vm._v("Close")])])])}
var staticRenderFns = []

export { render, staticRenderFns }